import React from "react";
import { Box, BoxProps } from "@chakra-ui/react";

interface SectionProps extends BoxProps {
  children?: React.ReactNode;
  isScrollable?: boolean;
}

function DashboardCardHeader({ children, ...props }: SectionProps) {
  return (
    <Box
      minHeight={"56px"}
      padding={"16px 16px 12px 16px"}
      display={"flex"}
      alignItems={"center"}
      gap={"12px"}
      {...props}
    >
      {children}
    </Box>
  );
}

function DashboardCardBody({ children, isScrollable, ...props }: SectionProps) {
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      flex={1}
      overflowY={isScrollable ? "auto" : "visible"}
      padding={isScrollable ? "0" : "0 16px 16px 16px"}
      {...props}
    >
      {children}
    </Box>
  );
}

interface Props {
  children?: React.ReactNode;
}

export default function DashboardCard({ children }: Props) {
  return (
    <Box
      borderRadius={"8px"}
      boxShadow={"0 0 0 0.5px #D4D4D1"}
      background={"#FFFFFF"}
      display={"flex"}
      flexDirection={"column"}
    >
      {children}
    </Box>
  );
}

DashboardCard.Header = DashboardCardHeader;
DashboardCard.Body = DashboardCardBody;
